Object.defineProperty(exports, '__esModule', { value: true });

var coreComponentsShared = require('../shared');
var components_caption_Component = require('./components/caption/Component.js');
var components_controls_Component = require('./components/controls/Component.js');
var components_graphic_Component = require('./components/graphic/Component.js');
var components_subtitle_Component = require('./components/subtitle/Component.js');
var components_title_Component = require('./components/title/Component.js');

function createCompound(functionComponent) {
    return Object.assign(functionComponent, {
        Graphic: components_graphic_Component.Graphic,
        Title: components_title_Component.Title,
        Subtitle: components_subtitle_Component.Subtitle,
        Caption: components_caption_Component.Caption,
        Controls: components_controls_Component.Controls,
    });
}
function getSystemMessageTestIds(dataTestId) {
    return {
        systemMessage: dataTestId,
        caption: coreComponentsShared.getDataTestId(dataTestId, 'caption'),
        controls: coreComponentsShared.getDataTestId(dataTestId, 'controls'),
        graphic: coreComponentsShared.getDataTestId(dataTestId, 'graphic'),
        subtitle: coreComponentsShared.getDataTestId(dataTestId, 'subtitle'),
        title: coreComponentsShared.getDataTestId(dataTestId, 'title'),
    };
}

exports.createCompound = createCompound;
exports.getSystemMessageTestIds = getSystemMessageTestIds;
